import styled from 'styled-components';

const LoaderContainer = styled.div(
  props => `
    background-image: linear-gradient(to right, #f4f4f4, #ececec);
  `
);

export const StatusLoader = styled.div`
  background-image: linear-gradient(to right, #dadada, #ececec);
  display: flex;
  width: 100%;
  height:18.5rem;
`;

export const DetailStarLoader = styled(LoaderContainer)`
  width: 10rem;
  height: 2rem;
  margin: 0.5rem;
`;

export const DetailHotelNameLoader = styled(LoaderContainer)`
  width: 40rem;
  height: 3rem;
  margin: 0.5rem;
`;

export const DetailAddressLoader = styled(LoaderContainer)`
  width: 50rem;
  height: 2rem;
  margin: 0.5rem;
`;

export const CheckinLoader = styled(LoaderContainer)`
  width: 10rem;
  height: 1.5rem;
  margin: 0.5rem;
`;

export const HotelImgLoader = styled(LoaderContainer)`
  width: 20rem;
  height: 16rem;
  margin: 0.5rem;
`;

export const LocationImgLoader = styled(LoaderContainer)`
  width: 17rem;
  height: 6rem;
  margin: 0.5rem;
`;

export const CheckInfoDateLoader = styled(LoaderContainer)`
  width: 4rem;
  height: 4rem;
  margin: 0.5rem;
`;

export const CheckDateMonthLoader = styled(LoaderContainer)`
  width: 10rem;
  height: 1.5rem;
  margin: 0.5rem;
`;

export const CheckTimeLoader = styled(LoaderContainer)`
  width: 10rem;
  height: 1.5rem;
  margin: 0.5rem;
`;

export const NightStayLoader = styled(LoaderContainer)`
  width: 10rem;
  height: 1.5rem;
  margin: 0.5rem;
`;

export const ActionLoader = styled(LoaderContainer)`
  width: 17rem;
  height: 2rem;
  margin: 0.5rem;
  margin-right: 10rem;
`;

export const RightActionLoader = styled(LoaderContainer)`
  width: 17rem;
  height: 2rem;
  margin: 2rem;
`;

export const RightSubActionLoader = styled(LoaderContainer)`
  width: 15rem;
  height: 1.5rem;
  margin: 1rem;
  margin-left: 2.5rem;
`;

export const TripInfoHeaderLoader = styled(LoaderContainer)`
  width: 20rem;
  height: 3rem;
  margin: 0.5rem;
`;

export const InfoLoader = styled(LoaderContainer)`
  width: 60rem;
  height: 1.5rem;
  margin: 0.5rem;
`;

export const InfoLoaderSmall = styled(LoaderContainer)`
  width: 50rem;
  height: 1.5rem;
  margin: 0.5rem;
`;


